const normalizeEmail = (email?: string | null): string => (email || '').trim().toLowerCase();

const configuredOpsEmails = (import.meta.env.VITE_PLATFORM_OPS_USERS || '')
  .split(',')
  .map((entry: string) => normalizeEmail(entry))
  .filter(Boolean);

const defaultOpsDomains = ['aspis.software'];

export const isAspisOperationsHost = (hostname?: string | null): boolean => {
  const host = (hostname || '').trim().toLowerCase();
  if (!host) return false;
  if (host === 'aspis.software') return true;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return false;
};

export const isPlatformOperator = (email?: string | null): boolean => {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;

  if (configuredOpsEmails.includes(normalized)) return true;

  const domain = normalized.split('@')[1] || '';
  return defaultOpsDomains.includes(domain);
};
